import UnderstandingReportName, { UnderstandingReportType, } from "@domains/entities/Reports/UnderstandingSection";
import { PNLTransactionErrorEnum, } from "../action-interfaces/Reports/PNLReport";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
class PNLTransactionReportPresenter {
    constructor(transactionUseCases, editTransactionUseCases, actions, understandUseCase, holdingTxnUseCase, originalTxn) {
        this.transactionUseCases = transactionUseCases;
        this.editTransactionUseCases = editTransactionUseCases;
        this.actions = actions;
        this.understandUseCase = understandUseCase;
        this.holdingTxnUseCase = holdingTxnUseCase;
        this.originalTxn = originalTxn;
    }
    getPNLTransactionsReportData(requestData) {
        this.actions.toggleTransactionShimmer(true);
        this.actions.hideViewTransactionReportpErrors(PNLTransactionErrorEnum.ERROR_DATA);
        this.actions.hideViewTransactionReportpErrors(PNLTransactionErrorEnum.TXNSTATUS);
        this.actions.hideEmptyValidationTxn();
        this.actions.getPNLTransactionsReportData({
            pnl: "",
            editableTransactionCount: 0,
            pnLTransactionDetails: [],
        });
        this.transactionUseCases.execute({
            onSuccess: (data) => {
                var _a;
                this.actions.toggleTransactionShimmer(false);
                this.PNLTransactionReportData = data;
                this.actions.getPNLTransactionsReportData(data);
                if (!data || ((_a = data === null || data === void 0 ? void 0 : data.pnLTransactionDetails) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TXN];
                    this.actions.setEmptyValidationTxn({ emptyValidation });
                }
            },
            onError: (error) => {
                this.actions.toggleTransactionShimmer(false);
                this.actions.setViewTransactionReportpErrors({
                    error,
                    isOpen: true,
                }, PNLTransactionErrorEnum.ERROR_DATA);
            },
        }, requestData);
    }
    setStockdetailsdata(data) {
        this.actions.setStockdetails(data);
    }
    setScreenState(state, goBackState = false) {
        this.actions.setScreenState(state, goBackState);
    }
    getRealisedUnderstandingSectionData() {
        const payload = {
            reportName: UnderstandingReportName.PNL,
            type: UnderstandingReportType.PNL_REPORT_REALISED,
        };
        this.understandUseCase.execute({
            onSuccess: (understandSectionData) => {
                this.actions.getRealisedUnderstandingSectionData(understandSectionData);
            },
            onError: (error) => {
                this.actions.setErrorUnderStandings({
                    error,
                    isOpen: true,
                });
            },
        }, payload);
    }
    getUnrealisedUnderstandingSectionData() {
        const payload = {
            reportName: UnderstandingReportName.PNL,
            type: UnderstandingReportType.PNL_REPORT_UNREALISED,
        };
        this.understandUseCase.execute({
            onSuccess: (understandSectionData) => {
                this.actions.getUnrealisedUnderstandingSectionData(understandSectionData);
            },
            onError: (error) => {
                this.actions.setErrorUnderStandings({
                    error,
                    isOpen: true,
                });
            },
        }, payload);
    }
    sendEditSplitPNLTransactionData(requestData) {
        const payload = {
            accountId: requestData.accountId,
            fromDate: requestData.fromDate,
            toDate: requestData.toDate,
            scripIdentifier: requestData.scripIdentifier,
            transactionType: requestData.transactionType,
            pnLEditSplitRequests: requestData.pnLEditSplitRequests,
            approximated: !!requestData.approximated,
        };
        this.actions.toggleEditSplitPNLTransaction(true);
        this.editTransactionUseCases.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.setViewTransactionReportpErrors({
                        error: null,
                        isOpen: data.valueOf(),
                    }, PNLTransactionErrorEnum.TXNSTATUS);
                }
                this.actions.toggleEditSplitPNLTransaction(false);
            },
            onError: (error) => {
                this.actions.setViewTransactionReportpErrors({
                    error: error,
                    isOpen: false,
                }, PNLTransactionErrorEnum.TXNSTATUS);
                this.actions.toggleEditSplitPNLTransaction(false);
            },
        }, payload);
    }
    holdingTransactionDetails(req) {
        this.actions.toggleTransactionShimmer(true);
        this.actions.hideViewTransactionReportpErrors(PNLTransactionErrorEnum.ERROR_DATA);
        this.actions.hideViewTransactionReportpErrors(PNLTransactionErrorEnum.TXNSTATUS);
        this.actions.getPNLTransactionsReportData({
            pnl: "",
            editableTransactionCount: 0,
            pnLTransactionDetails: [],
        });
        this.actions.hideEmptyValidationTxn();
        this.holdingTxnUseCase.execute({
            onSuccess: (data) => {
                var _a;
                this.actions.toggleTransactionShimmer(false);
                this.PNLTransactionReportData = data;
                this.actions.getPNLTransactionsReportData(data);
                if (!data || ((_a = data === null || data === void 0 ? void 0 : data.pnLTransactionDetails) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TXN];
                    this.actions.setEmptyValidationTxn({ emptyValidation });
                }
            },
            onError: (error) => {
                this.actions.toggleTransactionShimmer(false);
                this.actions.setViewTransactionReportpErrors({
                    error,
                    isOpen: true,
                }, PNLTransactionErrorEnum.ERROR_DATA);
            },
        }, req);
    }
    getOriginalTxns(requestData) {
        this.actions.originalTxnLoaderToggle(true);
        this.actions.hideViewTransactionReportpErrors(PNLTransactionErrorEnum.ORGTXN);
        this.originalTxn.execute({
            onSuccess: (originalTxns) => {
                this.actions.pnlOriginalTxn(originalTxns);
                this.actions.originalTxnLoaderToggle(false);
            },
            onError: (error) => {
                this.actions.setViewTransactionReportpErrors({
                    error,
                    isOpen: true,
                }, PNLTransactionErrorEnum.ORGTXN);
                this.actions.originalTxnLoaderToggle(false);
            },
        }, requestData);
    }
    clearOriginalTxn() {
        this.actions.pnlOriginalTxn([]);
        this.resetEditTransaction();
    }
    resetEditTransaction() {
        this.actions.setViewTransactionReportpErrors({
            error: null,
            isOpen: null,
        }, PNLTransactionErrorEnum.TXNSTATUS);
    }
}
export default PNLTransactionReportPresenter;
